var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('div',{style:({minHeight: _vm.Height+'px'}),attrs:{"id":"v-content"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }